var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cs-root cs-embed"},[(_vm.view)?_c(_vm.view,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }